import React, { useEffect, useState } from 'react';
import { Backdrop, Modal, Typography, Box, Fade, DialogTitle, DialogContentText, DialogContent, Dialog, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, TablePagination, Avatar, Button } from '@mui/material';
import RegisterClient from '../components/RegisterClient';
import axios from 'axios';
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%", // Asegura que el modal ocupe el 100% del ancho disponible
  maxWidth: 500, // Limita el tamaño máximo a 500px
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px", // Bordes redondeados
  textAlign: "center",
};
const Historial = () => {
  const [clientes, setClientes] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);

  const [scroll, setScroll] = useState('paper');
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [detailsReservation, setDetailsReservations] = useState(null);

console.log(detailsReservation)

  const DetailsReservation = async (reservationId) => {
    try {
      const response = await axios.get(`https://softwaregestion-production-b8ad.up.railway.app/api/reservate/${reservationId}`);
      setDetailsReservations(response.data.data);
    } catch (error) {
      console.error('Error consulta de clients:', error);
    }
  };

  const handleOpenStatus = (reservate) => {
    setOpenStatus(true); // Abre el modal
    setSelectedReservation(reservate);
    DetailsReservation(reservate.reservationId)

  };


  const handleCloseStatus = () => {

    setOpenStatus(false); // Abre el modal

  };
  const handleClickOpen = (scrollType, reservation) => () => {
    setScroll(scrollType);
    DetailsReservation(reservation.reservationId)

    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);


  };

  const descriptionElementRef = React.useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const Clients = async () => {
    try {
      const response = await axios.get('https://softwaregestion-production-b8ad.up.railway.app/api/all-reservate');
      const historial = response.data.data.filter((item) => item.status === "historial");
      setClientes(historial);
    } catch (error) {
      console.error('Error consulta de clients:', error);
    }
  };

  useEffect(() => {
    Clients();
  }, []);

  const handleSearch = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Extraer los clientes correctamente del array de reservas
  const extractedClients = clientes?.map(reserva => ({
    ...reserva.client,
    priceTotal: reserva.priceTotal, // Asegurar que se incluya el precio total en cada cliente
    services: reserva.services, // Asegurar que se incluya el precio total en cada cliente
    reservationId: reserva.id,
    reservationDate: reserva.reservationDate,
    reservationTime: reserva.reservationTime,

    employee: reserva.employee,
    status: reserva.status
  }));
  console.log(extractedClients)

  // Filtrar clientes por nombre o apellido
  const filteredClients = extractedClients.filter(cliente =>
    cliente.name.toLowerCase().includes(search.toLowerCase()) ||
    cliente.lastName.toLowerCase().includes(search.toLowerCase())
  );
  const updateAccount = async (newStatus) => {
    console.log(newStatus)
    try {
      const res = await axios.put(
        `https://softwaregestion-production-b8ad.up.railway.app/api/reservate/${selectedReservation.reservationId}`,
        { status: newStatus },

      );
      // Actualiza el estado local en el frontend
      Clients()
      handleCloseStatus()
    } catch (error) {
      console.error("Error al actualizar el estado del turno:", error);
    }
  };
  return (
    <>



      <Paper sx={{ width: '100%', overflow: 'hidden', padding: 2 }}>
        <TextField
          label="Buscar Cliente"
          variant="outlined"
          fullWidth
          margin="normal"
          value={search}
          onChange={handleSearch}
        />
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Nombre</TableCell>
                <TableCell>WhatsApp</TableCell>
                <TableCell>Correo electrónico</TableCell>
             {/*    <TableCell>Tipo de cliente</TableCell> */}
                <TableCell>Fecha y hora </TableCell>


                <TableCell>Total pagado</TableCell>
                <TableCell>Ver servicios</TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {filteredClients?.map((cliente) => (


                  <TableRow key={cliente.id}>
                    <TableCell>
                      <Avatar alt={cliente.name} src={cliente.avatar} />
                    </TableCell>
                    <TableCell>{cliente.name} {cliente.lastName}</TableCell>
                    <TableCell>{cliente.phone}</TableCell>
                    <TableCell>{cliente.email}</TableCell>
                 {/*    <TableCell>{cliente.type}</TableCell> */}
                    <TableCell>
                      {new Intl.DateTimeFormat('es-ES', { timeZone: 'UTC' }).format(new Date(cliente.reservationDate))}
                      {` ${cliente.reservationTime}`}
                    </TableCell>


                  


                    <TableCell>${cliente.priceTotal}</TableCell>
  <TableCell><Button variant='contained' onClick={handleClickOpen('paper', cliente)}>Ver</Button>
                    </TableCell>
                  </TableRow>

              ))}
            </TableBody>
          </Table>
        </TableContainer>
  
      </Paper>
      <React.Fragment >


        <Dialog
          open={open}
          onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          ref={descriptionElementRef}
          PaperProps={{
            style: {
              width: '80%', // Cambia este valor para ajustarlo al tamaño deseado
              maxWidth: 'none', // Evita que se aplique un límite de ancho máximo
            },
          }}
        >

          <DialogTitle id="scroll-dialog-title" sx={{ textAlign: "center" }}>Detalles de la Reserva</DialogTitle>
          <DialogContent dividers={scroll === 'paper'}    >
            {detailsReservation ? (
              <>
                <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: 'center', gap: "2em" }}>

                  <DialogContentText>
                    <strong>Cliente:</strong> {detailsReservation?.client?.name} {detailsReservation?.client?.lastName}
                    <br />
                    <strong>Servicios:</strong>
                    <ul>
                      {detailsReservation?.services?.map((service, index) => (
                        <li key={index}>{service} </li>
                      ))}
                    </ul>
                  </DialogContentText>
                  <DialogContentText>
                    <strong>Atendido por:</strong> {detailsReservation?.employee?.name} {detailsReservation?.employee?.lastName}
                  </DialogContentText>
                </Box>
                <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: 'center', }}>


                </Box>

                <DialogContentText sx={{ textAlign: "center" }}>
                  <strong>Monto Total:</strong> ${detailsReservation?.priceTotal}
                </DialogContentText>

              </>
            ) : (
              <DialogContentText>No hay datos disponibles.</DialogContentText>
            )}
          </DialogContent>
        </Dialog>
      </React.Fragment>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openStatus}
        onClose={handleCloseStatus}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openStatus}>
          <Box sx={style}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              ¿Ya se finalizo el servicio?
            </Typography>
            <Typography
              id="transition-modal-description"
              sx={{ mt: 2, display: "flex", gap: "2em", justifyContent: "center" }}
            >
              {/* Botón para cambiar el estado a 'activo' */}
              <Button
                variant="contained"
                onClick={() => updateAccount("finalizado")}

              >
                Si
              </Button>
              {/* Botón para cambiar el estado a 'cancelar' */}
              <Button
                variant="contained"
                onClick={() => handleCloseStatus()}
                sx={{
                  backgroundColor: "#f44336",
                  ":hover": { backgroundColor: "#f44336" },
                }}
              >
                no
              </Button>

            </Typography>
          </Box>
        </Fade>
      </Modal>


    </>
  );
};

export default Historial;
